import { useLocale } from '@mirai/locale';
import { Button, Icon, Pressable, Slider as SliderBase, useDevice, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { PRELOAD_IMAGES, SCROLL_DELAY } from './Slider.constants';
import { L10N } from './Slider.l10n';
import * as style from './Slider.module.css';
import { ICON } from '../../../../../helpers';

const Slider = ({
  captions = [],
  children,
  height,
  images = [],
  indicator = true,
  media: { url3D, urlVideo } = {},
  title,
  width,
  onCounter,
  onPress,
  onViewUrl = () => {},
  ...others
}) => {
  const { isMobile } = useDevice();
  const { translate } = useLocale();

  const [sliderIndex, setSliderIndex] = useState(0);

  const sliderProps = { className: [style.slider, others.className], style: { height, maxHeight: height } };

  const handleSliderIndex = (index) => {
    setSliderIndex(index);
  };

  // ! TODO: This should be part of the service of rates
  const buttonProps = { rounded: true, squared: true, transparent: true, className: style.button };

  return React.createElement(
    onPress ? Pressable : View,
    { ...sliderProps, 'aria-label': onPress ? title : undefined, onPress, role: onPress ? 'button' : undefined },
    <>
      <SliderBase
        counter
        {...{
          captions,
          height,
          images,
          indicator,
          width,
          onCounter,
          ...(isMobile
            ? {
                preloadImages: PRELOAD_IMAGES,
                scrollDelay: SCROLL_DELAY,
              }
            : {}),
        }}
        onChange={handleSliderIndex}
        {...sliderProps}
      />

      {children}

      {(url3D || urlVideo) && sliderIndex === 0 && (
        <View row className={style.buttons}>
          {urlVideo && (
            <Button
              {...buttonProps}
              tooltip={translate(L10N.LABEL_VIEW_VIDEO)}
              onPress={() => onViewUrl({ title: translate(L10N.LABEL_VIEW_VIDEO), url: urlVideo })}
            >
              <Icon headline level={2} value={ICON.PLAY} className={style.icon} />
            </Button>
          )}

          {url3D && (
            <Button
              {...buttonProps}
              tooltip={translate(L10N.LABEL_360_VIEW)}
              onPress={() => onViewUrl({ title: translate(L10N.LABEL_360_VIEW), url: url3D })}
            >
              <Icon headline level={2} value={ICON.VIEW_360} className={style.icon} />
            </Button>
          )}
        </View>
      )}
    </>,
  );
};

Slider.displayName = 'Mirai:Core:Rates:Item:Slider';

Slider.propTypes = {
  captions: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  height: PropTypes.number,
  images: PropTypes.arrayOf(PropTypes.string),
  indicator: PropTypes.bool,
  media: PropTypes.shape({
    url3D: PropTypes.string,
    urlVideo: PropTypes.string,
  }),
  title: PropTypes.string,
  width: PropTypes.number,
  onCounter: PropTypes.func,
  onPress: PropTypes.func,
  onViewUrl: PropTypes.func,
};

export { Slider };
